import { render, staticRenderFns } from "./GlobalPartnersDetailView.vue?vue&type=template&id=5478fa4a&scoped=true"
import script from "./GlobalPartnersDetailView.vue?vue&type=script&lang=js"
export * from "./GlobalPartnersDetailView.vue?vue&type=script&lang=js"
import style1 from "./GlobalPartnersDetailView.vue?vue&type=style&index=1&id=5478fa4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5478fa4a",
  null
  
)

export default component.exports